module.exports = __webpack_public_path__ + "media/img/prices/job-ad-caecc874fb2e4a617a76fe4f69158b14.png";